import {
  Text,
  FormControl,
  Checkbox,
  CheckboxGroup,
  Stack,
} from "@chakra-ui/react";
import { SEND_CONFIG_THEME } from "./theme";

interface ReceiptTypeCheckboxesProps {
  t: (key: React.Key) => string;
  value?: string[];
  onChange: (value: string[]) => void;
}

/**
 * Checkbox group component for receipt type selection
 * Extracted for better maintainability and reusability
 */
export function ReceiptTypeCheckboxes({
  t,
  value,
  onChange,
}: ReceiptTypeCheckboxesProps) {
  return (
    <>
      <Text color={SEND_CONFIG_THEME.colors.textPrimary} fontWeight="medium">
        {t("sendConfig.receipt")}
      </Text>
      <FormControl isRequired>
        <CheckboxGroup value={value} onChange={onChange}>
          <Stack direction={["column"]}>
            <Checkbox value="sendUpdates">
              <Text
                color={SEND_CONFIG_THEME.colors.textPrimary}
                fontSize={SEND_CONFIG_THEME.fontSize.title}
              >
                {t("sendConfig.receiptOptions.sendUpdates")}
              </Text>
            </Checkbox>
            <Checkbox value="sendCancellations">
              <Text
                color={SEND_CONFIG_THEME.colors.textPrimary}
                fontSize={SEND_CONFIG_THEME.fontSize.title}
                pt={1}
              >
                {t("sendConfig.receiptOptions.sendCancellations")}
              </Text>
            </Checkbox>
          </Stack>
        </CheckboxGroup>
      </FormControl>
    </>
  );
}
